import React, { useState } from "react";
import {
    Box,
    IconButton,
    Popover,
    SxProps,
    Theme,
    Tooltip,
    Typography,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

interface FieldInfoButtonProps {
    tooltip: string;
    sx?: SxProps<Theme>;
}

export const FieldInfoButton = ({ tooltip, sx }: FieldInfoButtonProps) => {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const open = Boolean(anchorEl);

    const handleClick = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        setAnchorEl(anchorEl ? null : e.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Tooltip title={tooltip} arrow placement="top">
                <IconButton
                    size="small"
                    onClick={handleClick}
                    aria-label="Field information"
                    sx={{
                        p: 0,
                        color: "text.secondary",
                        flexShrink: 0,
                        "&:hover": { backgroundColor: "transparent" },
                        ...sx,
                    }}
                >
                    <InfoOutlinedIcon sx={{ fontSize: 16 }} />
                </IconButton>
            </Tooltip>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                onClick={(e) => e.stopPropagation()}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
            >
                <Box sx={{ p: 2, maxWidth: 300 }}>
                    <Typography variant="body2" color="text.secondary">
                        {tooltip}
                    </Typography>
                </Box>
            </Popover>
        </>
    );
};
